import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component,  Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { Subject, takeUntil } from 'rxjs';

interface Item {
    name: string;
    function: string;
    index?: number,
    field?: string;
}

@Component({
    selector: 'clever-carrentselectedfilters',
    templateUrl: './carrentselectedfilters.component.html',
    styleUrls: ['./carrentselectedfilters.component.scss'],
    standalone: false
})
export class CarrentselectedfiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() isDisabled: boolean = false;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    list: Item[] = [];
    filter: CarrentFilters;
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected carrentFilter: CarrentFiltersService,
        protected cdr: ChangeDetectorRef,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    initFilterSub(): void {
        this.carrentFilter.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: CarrentFilters) => {
            if (filter) {
                this.checkFilters(filter);
            }
        });
    }

    checkFilters(filter): void {
        this.list = [];
        this.cdr.detectChanges();
        this.filter = JSON.parse(JSON.stringify(filter));
        this.checkF('pkt');
        this.checkF('trg');
        this.checkF('inc');
        this.checkF('ins');
        this.checkF('fkl');
        this.checkF('fty');
        this.checkF('opi');
        this.carrentFilter.setExtraCount(this.list.length);
    }

    async resetAll() {
        this.carrentFilter.resetExtraforletters();
    }

    checkF(filed): void {
        if (this.filter?.filters?.[filed]?.filterList?.length > 0) {
            for (let i = 0; i < this.filter.filters[filed].filterList.length; i++) {
                if (this.filter.filters[filed].filterList[i].selected) {
                    this.list.push({
                        name: this.filter.filters[filed].filterList[i].name,
                        function: 'removefield',
                        index: i,
                        field: filed
                    });
                }
            }
        }
    }

    async removefield(index, field) {
        if (this.filter?.filters?.[field]?.filterList[index]) {
            this.filter.filters[field].filterList[index].selected = false;
            this.carrentFilter.fieldResult(this.filter.filters[field].filterList, false, field);
        }
    }
}
